import { html, escapeHtml, isTrusted, markTrusted } from '../../../ContentComposer/ContentComposer.js';

export function _generateFormHtml(modal, fields) {
    const formFields = fields.map(f => modal._generateFieldHtml(f));
    return html`<div class="gm-form">${formFields}</div>`;
}

export function _getFormData(modal) {
    const { $body } = modal.elements;
    const fields = modal._getAllFields();
    if (!fields || fields.length === 0) return {};
    
    const data = {};
    fields.forEach(f => {
        if (!f.id || f.type === 'heading' || f.type === 'columns') return;
        if (f.type === 'radioGroup') {
            data[f.id] = $body.find(`input[name="${f.id}"]:checked`).val();
            return;
        }
        if (f.type === 'checkbox') {
            const $chk = $body.find('#' + f.id);
            const isChecked = $chk.is(':checked');
            data[f.id] = f.value !== undefined ? (isChecked ? f.value : false) : isChecked;
            return;
        }
        data[f.id] = $body.find('#' + f.id).val();
    });
    return data;
}

export function _attachFormFieldAccess(modal) {
    const { $body } = modal.elements;
    if (!$body) return;

    const fields = {};
    if (modal.settings.fields && modal.settings.fields.length > 0) {
        modal._getAllFields().forEach(f => {
            if (!f.id || f.type === 'heading' || f.type === 'columns') return;
            fields[f.id] = f.type === 'radioGroup'
                ? $body.find(`input[name="${f.id}"]`)
                : $body.find('#' + f.id);
        });
    }

    $body.fields = fields;
    $body.gmData = () => modal._getFormData();
}

export function _populateBatchTable(modal) {
    const $ = window.jQuery;
    const $body = modal.elements.$body;
    const $table = $body.find('#gm-batch-table');
    if (!$table.length) return;

    const rows = modal.settings.items.map((item, index) => {
        const cells = modal.settings.batchColumns.map(col => html`<td>${item[col.field] || ''}</td>`);
        return html`
            <tr data-item-index="${index}">
                ${cells}
                <td class="gm-text-center gm-batch-status">
                    <span class="gm-badge gm-badge-light">PENDING</span>
                </td>
            </tr>`;
    });

    const tbody = $('<tbody></tbody>').append(rows.map(r => r.toString()));
    $table.append(tbody);
}

